import { Box, Typography } from '@mui/material';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { PricebookBundle } from '../models/PricebookData';
import { Svgs } from '../assets/svg';
import { getActivePrice, getPriceWithIntervalLabel } from '../helpers/pricebookUtils';

const appendToBody = () => document.body;

interface BundledTagProps {
  addOnPricebook?: PricebookBundle;
}

const BundledTag: React.FC<BundledTagProps> = ({ addOnPricebook }) => {
  const activePrice = addOnPricebook ? getActivePrice(addOnPricebook.prices) : undefined;
  const addOnDetails = addOnPricebook
    ? [
        { label: 'Name', value: addOnPricebook.pricebook.pricebookName },
        { label: 'Price', value: activePrice?.price ? getPriceWithIntervalLabel(activePrice) : '' },
        { label: 'Description', value: addOnPricebook.pricebook.internalAdminDescription },
      ].filter(({ value }) => value?.trim())
    : [];

  return (
    <Tippy
      content={
        <Box>
          <Typography
            component='div'
            variant='p18Bold'
            color='secondary.dark'
            sx={{ lineHeight: '24px' }}>
            Bundled
          </Typography>
          <Typography
            component='div'
            variant='p16Light'
            color='secondary.dark'
            sx={{ mt: 1.25, lineHeight: '22px' }}>
            Members can choose to pay for an add-on with the following details.
          </Typography>
          {addOnDetails.length > 0 && (
            <Box
              component='ul'
              sx={{
                m: 0,
                mt: 1.25,
                p: 0,
                listStyle: 'none',
                display: 'flex',
                flexDirection: 'column',
                rowGap: 0.25,
              }}>
              {addOnDetails.map(({ label, value }) => (
                <Box key={label} component='li' sx={{ display: 'flex' }}>
                  <Typography
                    component='span'
                    variant='p16Light'
                    color='secondary.dark'
                    aria-hidden
                    sx={{ width: '36px', pl: '10px', flexShrink: 0, lineHeight: '22px' }}>
                    •
                  </Typography>
                  <Typography
                    component='span'
                    variant='p16Light'
                    color='secondary.dark'
                    sx={{ lineHeight: '22px' }}>
                    <Typography component='span' variant='p16SemiBold' sx={{ lineHeight: '22px' }}>
                      {label}:{' '}
                    </Typography>
                    {value}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      }
      placement='top'
      arrow
      theme='tippy-rounded'
      maxWidth={380}
      trigger='mouseenter focus'
      appendTo={appendToBody}>
      <Box className='pricebook-tag' role='button' tabIndex={0}>
        <Svgs.IconBundled />
        <Typography variant='p12'>Bundled</Typography>
      </Box>
    </Tippy>
  );
};

export default BundledTag;
